export default {"src":"/_next/static/media/mobile-logo.39469679.svg","height":30,"width":117};